module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/agency-default-small.d8cc1391e4f79735d9e9501118e2343a.jpg";